import debug from 'debug';
const log = debug('fus078/components/contact-form');

log('load');

export const ELEMENT_SELECTOR = '[data-contact-form]';

$(document).on('ready markupLoaded', () => {
	const $element = $(ELEMENT_SELECTOR);
	if ($element && $element.length > 0) {
		log('mount.plugin', $element);

		System.import(
			/* webpackChunkName: "components/contactForm" */
			'./component.js')
			.then(({ contactForm }) => {
				// console.log('adaptiveField', adaptiveField);
				$element.each((index, element) => new contactForm(element));
			});
	}
});



// WEBPACK FOOTER //
// ./client/src/site__fus078/components/contact-form/index.js